<template>
  <div
    class="border p-2 pl-4 pr-4 rounded mb-2"
    style="display:grid; grid-template-columns: 2fr 2fr 1fr; align-items: center;"
  >
    <div class="d-flex align-items-center">
      <div class="img"></div>
      <div class="ml-3">
        <p class="mb-0">{{ clientName }}</p>
        <small>{{ clientEmail }}</small>
      </div>
    </div>

    <div class="d-flex align-items-center pl-3" style="flex-direction: column;">
      <div class="progress mb-2" style="height: 15px; width: 70%;">
        <div
          class="progress-bar"
          role="progressbar"
          :style="`width: ${consumedPointsPercentage}%;`"
          :aria-valuenow="consumedPointsPercentage"
          aria-valuemin="0"
          aria-valuemax="100"
        >
          {{ consumedPointsPercentage }}%
        </div>
      </div>
      <small>{{ consumedPoints }} points consumed</small>
    </div>

    <div class="d-flex justify-content-end">
      <font-awesome-icon icon="play" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ClientCard",
  props: [
    "clientName",
    "clientEmail",
    "consumedPointsPercentage",
    "consumedPoints",
  ],
};
</script>

<style lang="scss" scoped>
.img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: grey;
}
</style>
